import script from "./deploymentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./deploymentForm.vue?vue&type=script&setup=true&lang=js"

import "./deploymentForm.vue?vue&type=style&index=0&id=3f5a55dc&lang=css"

const __exports__ = script;

export default __exports__